import axios from "axios";

export default {
  getSimulation(simulationData) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.CHECK_SERVICE_PUBLIC_PATH}/price`,
        params: { fallback: 1 },
        data: simulationData
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/checkService.js